import services from 'services/module';
import {tapfiliateLib} from '../lazy_modules';
import {LocalStorageSvc} from './LocalStorageSvc';
import {HttpSvcFactory} from './HttpSvc';
import {Utils} from '../underscore-extensions';

interface AffiliateLocalStore {
    id: string;
    headerName: string;
}

export class AffiliateSvc {
    private tapId = options.isProduction ? '4142-17375a' : '4717-bb729d';
    private storageName = 'anm_referrral_program';
    private getReferralRequest = () => this.HttpSvc(`referral/foruser?product=${Utils.getProduct()}`);

    constructor(private $location: ng.ILocationService,
                private $q: ng.IQService,
                private LocalStorageSvc: LocalStorageSvc,
                private HttpSvc: HttpSvcFactory) {
    }

    isAffiliate() {
        const {tap_a, cjevent} = this.$location.search() as anm.AffiliateParams;
        return tap_a || cjevent;
    }

    isTapAffiliate() {
        const {tap_a} = this.$location.search() as anm.AffiliateParams;
        return !!tap_a;
    }

    init() {
        if (!this.isAffiliate()) return;

        const {tap_a, cjevent} = this.$location.search() as anm.AffiliateParams;

        if (tap_a) {
            this.detectTap();
        } else if (cjevent) {
            this.setAffiliateInfo(cjevent, 'anm-ref-cjevent');

        }
    }

    getAffiliateUser() {
        const request = this.getReferralRequest();
        return request.secureGet()
            .then(r => r.data)
            .then((affiliateInfo: ApiError | anm.AffiliateInfo) => {
                return Utils.isApiError(affiliateInfo) ? this.$q.reject() : affiliateInfo;
            });
    }

    getAffiliateHeader() {
        const storage = this.LocalStorageSvc.get<AffiliateLocalStore>(this.storageName);
        if (!storage) return null;

        const {id, headerName} = storage;
        return {[headerName]: id};
    }

    private setAffiliateInfo(id: string, headerName: string) {
        this.LocalStorageSvc.set<AffiliateLocalStore>(this.storageName, {
            id,
            headerName
        });
    }

    private loadLib() {
        const deferred = this.$q.defer();
        loadScripts([tapfiliateLib], () => deferred.resolve());
        return deferred.promise;
    }

    private detectTap() {
        this.loadLib().then(() => {
            window.tap.create(this.tapId);
            window.tap.detectClick(({id}: any) => this.setAffiliateInfo(id, 'anm-ref-tap'));
        });
    }

}

services.service('affiliateSvc', AffiliateSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/AffiliateSvc.ts